import React, { useEffect } from 'react';
import '../styles/Photos.css'; // Import your custom CSS for Photos component

export default function Photos({ photos, keyword }) {
    useEffect(() => {
        return () => {
            // Clean up photos when component unmounts or keyword changes
            console.log('Cleaning up photos');
        };
    }, [keyword]);

    if (photos) {
        return (
            <div className="gallery">
                <div className="gallery-title-container">
                    <img 
                        src="https://media1.giphy.com/media/Z968Qd9K6UBO4uj7Oc/giphy.gif?cid=6c09b952zfgy5w9hjbayk84akcryzi7859egss3xvn4wg1en&ep=v1_internal_gif_by_id&rid=giphy.gif&ct=s" 
                        alt="Animated star" 
                        className="gallery-gif"
                    />
                    <h2 className="gallery-title">Gallery</h2>
                    <img 
                        src="https://media1.giphy.com/media/Z968Qd9K6UBO4uj7Oc/giphy.gif?cid=6c09b952zfgy5w9hjbayk84akcryzi7859egss3xvn4wg1en&ep=v1_internal_gif_by_id&rid=giphy.gif&ct=s" 
                        alt="Animated star" 
                        className="gallery-gif"
                    />
                </div>
            
            
            <div className="photos-container">
                
                {photos.map((photo, index) => (
                    <div key={index} className="photo-item">
                        <img src={photo.src.landscape} alt={keyword} className="photo-image" />
                    </div>
                ))}
            </div>
            </div>
        );
    } else {
        return null;
    }
}
